module.exports = __webpack_public_path__ + "static/blog-9b197817532f477b06cfb625f52edff8.jpg";